export default __webpack_public_path__ + "static/service-residential-wireless-b54de03ac4e885411bdd6ea71146c839.jpg";